import { createTRPCReact } from "@trpc/react-query";
import { AppRouter } from "./router/_app";
import type { QueryClient } from "@tanstack/react-query";
import { createQueryClient } from "./query-client";
import { inferRouterInputs, inferRouterOutputs } from "@trpc/server";

let clientQueryClientSingleton: QueryClient | undefined = undefined;
export const getQueryClient = () => {
  if (typeof window === "undefined") {
    // Server: always make a new query client
    return createQueryClient();
  } else {
    // Browser: use singleton pattern to keep the same query client
    return (clientQueryClientSingleton ??= createQueryClient());
  }
};

// @ts-ignore
export const trpc = createTRPCReact<AppRouter>();

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;
